import { createBrowserRouter } from 'react-router-dom';
import { AppShell } from './shell/AppShell';
import { RequireAuth } from './shell/RequireAuth';
import VaultScreen from './screens/VaultScreen';
import RecipientFormScreen from './screens/RecipientFormScreen';
import MessagesScreen from './screens/MessagesScreen';
import AllMessagesScreen from './screens/AllMessagesScreen';
import RecordScreen from './screens/RecordScreen';
import GuardiansScreen from './screens/GuardiansScreen';
import GuardianFormScreen from './screens/GuardianFormScreen';
import GuardianReplaceScreen from './screens/GuardianReplaceScreen';
import ExecutorsScreen from './screens/ExecutorsScreen';
import ExecutorFormScreen from './screens/ExecutorFormScreen';
import SeniorRecordingsScreen from './screens/SeniorRecordingsScreen';
import SeniorReviewScreen from './screens/SeniorReviewScreen';
import RepliesScreen from './screens/RepliesScreen';
import YouScreen from './screens/YouScreen';
import SignInScreen from './screens/SignInScreen';
import SetPasswordScreen from './screens/SetPasswordScreen';
import WelcomeSignupScreen from './screens/WelcomeSignupScreen';
import VerifyOtpScreen from './screens/VerifyOtpScreen';
import EnrollPasskeyScreen from './screens/EnrollPasskeyScreen';
import RecoverScreen from './screens/RecoverScreen';
import RecoverWithKitScreen from './screens/RecoverWithKitScreen';
import RecoveryStopScreen from './screens/RecoveryStopScreen';
import RecoveryKitScreen from './screens/RecoveryKitScreen';
import NotFoundScreen from './screens/NotFoundScreen';

export const router = createBrowserRouter([
  { path: '/signin', element: <SignInScreen /> },
  // Public: whoever follows the emailed link has no session yet by definition.
  { path: '/set-password', element: <SetPasswordScreen /> },
  { path: '/welcome', element: <WelcomeSignupScreen /> },
  { path: '/verify', element: <VerifyOtpScreen /> },
  { path: '/enroll', element: <EnrollPasskeyScreen /> },
  // Reached by people who CANNOT sign in, so they sit outside RequireAuth.
  // /recover/kit is the exception — it needs a session and says so itself
  // rather than bouncing someone to a sign-in page they may not understand.
  { path: '/recover', element: <RecoverScreen /> },
  { path: '/recover/kit', element: <RecoverWithKitScreen /> },
  // The link in every recovery notice. Opened by advisors and guardians who
  // have no account with us at all.
  { path: '/recovery/stop', element: <RecoveryStopScreen /> },
  {
    path: '/',
    element: <RequireAuth><AppShell /></RequireAuth>,
    errorElement: <NotFoundScreen />,
    children: [
      { index: true, element: <VaultScreen /> },
      { path: 'recipients/new', element: <RecipientFormScreen /> },
      { path: 'recipients/:id/edit', element: <RecipientFormScreen /> },
      { path: 'recipients/:id/messages', element: <MessagesScreen /> },
      { path: 'messages', element: <AllMessagesScreen /> },
      { path: 'record', element: <RecordScreen /> },
      { path: 'guardians', element: <GuardiansScreen /> },
      { path: 'guardians/new', element: <GuardianFormScreen /> },
      { path: 'guardians/:id/replace', element: <GuardianReplaceScreen /> },
      { path: 'executors', element: <ExecutorsScreen /> },
      { path: 'executors/new', element: <ExecutorFormScreen /> },
      { path: 'recordings', element: <SeniorRecordingsScreen /> },
      { path: 'recordings/:messageId/review', element: <SeniorReviewScreen /> },
      { path: 'replies', element: <RepliesScreen /> },
      { path: 'you', element: <YouScreen /> },
      { path: 'you/recovery-kit', element: <RecoveryKitScreen /> },
    ],
  },
  { path: '*', element: <NotFoundScreen /> },
]);
